"use client";

export default function Home() {
  return (
    <div className="space-y-12">
      <section className="text-center">
        <h1 className="text-5xl font-serif font-bold text-emerald-800 mb-4">
          Welcome to Gourmet Bistro
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          Experience culinary excellence in an elegant atmosphere. Our seasonal
          menu features locally-sourced ingredients crafted into unforgettable
          dishes.
        </p>
      </section>

      <section className="grid md:grid-cols-3 gap-8">
        <div className="text-center p-6 bg-emerald-50 rounded-lg">
          <h3 className="text-2xl font-serif font-bold text-emerald-800 mb-2">
            Fresh Ingredients
          </h3>
          <p className="text-gray-600">Locally sourced, seasonally inspired</p>
        </div>
        <div className="text-center p-6 bg-emerald-50 rounded-lg">
          <h3 className="text-2xl font-serif font-bold text-emerald-800 mb-2">
            Fine Dining
          </h3>
          <p className="text-gray-600">
            Elegant atmosphere, exceptional service
          </p>
        </div>
        <div className="text-center p-6 bg-emerald-50 rounded-lg">
          <h3 className="text-2xl font-serif font-bold text-emerald-800 mb-2">
            Wine Selection
          </h3>
          <p className="text-gray-600">Curated pairings for every dish</p>
        </div>
      </section>

      <section className="text-center">
        <button className="px-8 py-3 bg-emerald-700 text-white rounded-lg hover:bg-emerald-800 transition text-lg font-semibold">
          View Our Menu
        </button>
      </section>
    </div>
  );
}
